export const sanitizeNumberInput = (value: string) => value.replace(/[^0-9.-]+/, "");
